import { render } from "./EregForm.vue?vue&type=template&id=0ab7bb60&scoped=true"
import script from "./EregForm.vue?vue&type=script&lang=js"
export * from "./EregForm.vue?vue&type=script&lang=js"

import "./EregForm.vue?vue&type=style&index=0&id=0ab7bb60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ab7bb60"]])

export default __exports__